(() => {
  angular
    .module('complianceFrameworkApp.tridCalculator')
    .controller('TridCalculatorController', TridCalculatorController);

  /* eslint-disable no-undef */
  /* ngInject */
  function TridCalculatorController(sessionService) {

    const vm = this;

    vm.alerts = [];
    vm.calculate = calculate;
    vm.advanceDate = advanceDate;
    vm.backstepDate = backstepDate;
    vm.isSaturday = isSaturday;
    vm.isSunday = isSunday;
    vm.isHoliday = isHoliday;
    vm.isValidDay = isValidDay;
    vm.handleValidDayWarning = handleValidDayWarning;
    vm.handleDateApplicationReceived = handleDateApplicationReceived;
    vm.handleDateApplicantProvidedIntentToProceed = handleDateApplicantProvidedIntentToProceed;
    vm.handleCDProvidedFor = handleCDProvidedFor;
    vm.handleDateInitialLoanEstimateMustBeDelivered = handleDateInitialLoanEstimateMustBeDelivered;
    vm.handleEarliestDateInitialEstimateForAllChargesAvailable = handleEarliestDateInitialEstimateForAllChargesAvailable;
    vm.handleEarliestDateLoanMayClose = handleEarliestDateLoanMayClose;
    vm.handleFinalLEDelivered = handleFinalLEDelivered;
    vm.handleDateFinalValidLEMustBeReceived = handleDateFinalValidLEMustBeReceived;
    vm.handleDateFinalValidRevisedLEConsideredReceived = handleDateFinalValidRevisedLEConsideredReceived;
    vm.handleDateCDConsideredReceived = handleDateCDConsideredReceived;
    vm.handleFinalDateToProvideCDForClosingDate = handleFinalDateToProvideCDForClosingDate;
    vm.handleRevisedDateLoanMayCloseForEmailedCD = handleRevisedDateLoanMayCloseForEmailedCD;
    vm.handleRevisedDateLoanMayClose = handleRevisedDateLoanMayClose;
    vm.handleConsummationViolation = handleConsummationViolation;
    vm.handleDateRevisedCDConsideredReceived = handleDateRevisedCDConsideredReceived;
    vm.handleRevisedDateLoanMayCloseFromRevisedCD = handleRevisedDateLoanMayCloseFromRevisedCD;
    vm.handleRevisedCDViolation = handleRevisedCDViolation;
    vm.handleDateFinalCDMustBeAvailable = handleDateFinalCDMustBeAvailable;
    vm.handleEarliestDateFundsMayBeDisbursed = handleEarliestDateFundsMayBeDisbursed;
    vm.handleAnticipatedActualDateOfClosing = handleAnticipatedActualDateOfClosing;
    vm.handleWarningOnEarlyCD = handleWarningOnEarlyCD;
    vm.handleWarningOnLateLE = handleWarningOnLateLE;
    vm.handleWarningOnLateRevisedLE = handleWarningOnLateRevisedLE;
    vm.handleWarningOnLateCD = handleWarningOnLateCD;
    vm.handleWarningOnLateRevisedCD = handleWarningOnLateRevisedCD;
    vm.sessionService = sessionService;

    vm.calculator = {
      change_circumstance: 'No',
      is_loan_rescindable: 'No',
      saturdays: 'Yes',
      date_cd_affirmed: ''
    };

    vm.calculate(vm.calculator);

    // When called, fires everything. Yes, everything. Hopefully in order, so that dates that are updated twice do not break.
    function calculate(calculator) {
      vm.handleDateApplicationReceived(calculator);
      vm.handleDateApplicantProvidedIntentToProceed(calculator);
      vm.handleCDProvidedFor(calculator);
      vm.handleDateInitialLoanEstimateMustBeDelivered(calculator);
      vm.handleEarliestDateInitialEstimateForAllChargesAvailable(calculator);
      vm.handleEarliestDateLoanMayClose(calculator);
      vm.handleFinalLEDelivered(calculator);
      vm.handleDateFinalValidLEMustBeReceived(calculator);
      vm.handleDateFinalValidRevisedLEConsideredReceived(calculator);
      vm.handleWarningOnEarlyCD(calculator);
      vm.handleDateCDConsideredReceived(calculator);
      vm.handleFinalDateToProvideCDForClosingDate(calculator);
      vm.handleRevisedDateLoanMayClose(calculator);
      vm.handleRevisedDateLoanMayCloseForEmailedCD(calculator);
      vm.handleConsummationViolation(calculator);
      vm.handleDateRevisedCDConsideredReceived(calculator);
      vm.handleRevisedDateLoanMayCloseFromRevisedCD(calculator);
      vm.handleRevisedCDViolation(calculator);
      vm.handleDateFinalCDMustBeAvailable(calculator);
      vm.handleAnticipatedActualDateOfClosing(calculator);
      vm.handleEarliestDateFundsMayBeDisbursed(calculator);
      vm.handleWarningOnLateLE(calculator);
      vm.handleWarningOnLateRevisedLE(calculator);
      vm.handleWarningOnLateCD(calculator);
      vm.handleWarningOnLateRevisedCD(calculator);
    }

    // Functions that will be used everywhere. This includes checking for Saturdays, Sundays, Holidays, Stepping thru dates, etc.
    function advanceDate(input_date, num_days, regardless, calculator) {
      var countDate = moment(input_date);
      var saturdays = calculator.saturdays;
      // let regardless = calculator.regardless;
      var i = 0;
      while (i < num_days) {
        if (vm.isValidDay(countDate, saturdays, regardless) == true) {
          countDate = countDate.add(1, 'days');
          i++;
        } else {
          countDate = countDate.add(1, 'days');
          // i++;
        }
        while (vm.isValidDay(countDate, saturdays, regardless) == false) {
          countDate = countDate.add(1, 'days');
        }
      }
      return countDate;
    }

    function backstepDate(input_date, num_days, regardless, calculator) {
      var countDate = moment(input_date);
      var saturdays = calculator.saturdays;
      var i = 0;

      while (i < num_days) {
        if (vm.isValidDay(countDate, saturdays, regardless) == true) {
          countDate = countDate.subtract(1, 'days');
          i++;
        } else {
          countDate = countDate.subtract(1, 'days');
        }
        while (vm.isValidDay(countDate, saturdays, regardless) == false) {
          countDate = countDate.subtract(1, 'days');
        }
      }
      return countDate;
    }

    function isSaturday(date){
      if (date.day() == 6){
        return true;
      } else {
        return false;
      }
    }

    function isSunday(date){
      if (date.day() == 0) {
        return true;
      }
    }

    // TODO : make this work as simply as this, it should be this easy.
    // STUB
    function isHoliday(date) {
      var holidays = ['01/01/2021', '01/18/2021', '02/15/2021', '05/31/2021', '07/05/2021', '09/06/2021', '10/11/2021', '11/11/2021', '11/25/2021', '12/25/2021', '01/01/2022', '01/17/2022',  '02/21/2022', '05/30/2022', '06/20/2022' ,' 07/04/2022', '09/05/2022', '10/10/2022', '11/11/2022', '11/24/2022', '12/26/2022', '01/02/2023', '01/16/2023', '02/20/2023', '05/29/2023', '06/19/2023' ,'07/04/2023', '09/04/2023', '10/09/2023', '11/11/2023', '11/23/2023', '12/25/2023', '01/01/2024', '01/15/2024',  '02/19/2024', '05/27/2024', '06/19/2024' ,' 07/04/2024', '09/02/2024', '10/14/2024', '11/11/2024', '11/28/2024', '12/25/2024', '01/01/2025', '01/20/2025',  '02/17/2025', '05/26/2025', '06/19/2025' ,' 07/04/2025', '09/01/2025', '10/13/2025', '11/11/2025', '11/27/2025', '12/25/2025'];
      for (var i = holidays.length - 1; i >= 0; i--) {
        if (date.format('L') == holidays[i]) {
          return true;
        }
      }
    }

    function isValidDay(date, saturdays, regardless) {
      if (vm.isHoliday(date)) {
        return false;
      }
      else if (vm.isSaturday(date) && regardless === 'Yes') {
        return true;
      }
      else if (vm.isSaturday(date) && saturdays === 'No') {
        return false;
      }
      else if (vm.isSunday(date)) {
        return false;
      } else {
        return true;
      }
    }

    // Handle "events" here that need to trigger warnings.
    function handleValidDayWarning(input_date, calculator) {
      if (input_date) {
        var dateCheck = new Date(input_date);
        if (vm.isValidDay(moment(dateCheck), calculator.saturdays, calculator.regardless) == false) {
          calculator.invalid_date_warning = true;
        }else {
          calculator.invalid_date_warning = false;
        }
      }
    }

    function handleDateApplicationReceived(calculator) {
      var dateApplicationReceived = new Date(calculator.date_application_received);
      var tridCutoffDate = new Date('10/03/2015');
      calculator.date_application_received_warning = dateApplicationReceived < tridCutoffDate;
    }

    function handleDateApplicantProvidedIntentToProceed(calculator) {
      var dateIntent = new Date(calculator.date_intent);
      var dateLeProvided = new Date(calculator.date_le_provided);
      var dateInitEstimate = new Date(calculator.date_init_estimate_for_all_charges_available);
      calculator.date_applicant_warning = dateIntent < dateLeProvided;
      calculator.date_applicant_warning_two = (dateIntent.getTime() === dateLeProvided.getTime());
      calculator.date_applicant_warning_three = (dateIntent > dateLeProvided && dateIntent <= dateInitEstimate);
      calculator.date_applicant_warning_four = dateIntent > dateInitEstimate;
    }

    function handleCDProvidedFor(calculator) {
      if (calculator.cd_provided_before === 'Yes') {
        calculator.cd_provided_warning = true;
      } else {
        calculator.cd_provided_warning = false;
      }
    }

    // Handle "events" here that need to trigger calculations.
    function handleDateInitialLoanEstimateMustBeDelivered(calculator) {
      if (calculator.date_application_received) {
        var dateInitialLoanEstimateMustBeDelivered = new Date(calculator.date_application_received);
        calculator.date_init_le_must_be_delivered = vm.advanceDate(dateInitialLoanEstimateMustBeDelivered, 3, calculator.saturdays, calculator);
      }
    }

    // 10 business days.
    function handleEarliestDateInitialEstimateForAllChargesAvailable(calculator) {
      if (calculator.date_le_provided) {
        var dateInitialEstimateForAllChargesAvailable = new Date(calculator.date_le_provided);
        calculator.date_init_estimate_for_all_charges_available = vm.advanceDate(dateInitialEstimateForAllChargesAvailable, 10, 'No', calculator);
      }
    }

    // 7 business days regardless.
    function handleEarliestDateLoanMayClose(calculator) {
      if (calculator.date_le_provided) {
        var dateLoanMayClose = new Date(calculator.date_le_provided);
        calculator.earliest_date_loan_may_close = vm.advanceDate(dateLoanMayClose, 7, 'Yes', calculator);
      }
    }

    // check this one!
    function handleFinalLEDelivered(calculator) {
      if (calculator.date_learned_last_trigger) {
        var finalLEDelivered = new Date(calculator.date_learned_last_trigger);
        calculator.date_final_le_must_be_delivered = vm.advanceDate(finalLEDelivered, 3, 'No', calculator);
      }
    }

    function handleDateFinalValidLEMustBeReceived(calculator) {
      if (calculator.date_initial_cd_provided) {
        var dateFinalLEReceived = new Date(calculator.date_initial_cd_provided);
        calculator.date_final_valid_revised_le_received = vm.backstepDate(dateFinalLEReceived, 1, 'Yes', calculator);
      }
    }

     // Complicated! Number 29 on the specs.
    function handleDateFinalValidRevisedLEConsideredReceived(calculator) {
      if (calculator.how_final_valid_revised_le_provided) {
        if (calculator.how_final_valid_revised_le_provided == 'Hand delivered') {
          calculator.date_final_valid_revised_le_considered_received = moment(calculator.date_final_valid_revised_le_provided);
          return;
        } else {
          if (calculator.date_revised_le_received) {
            calculator.date_final_valid_revised_le_considered_received = moment(calculator.date_revised_le_received);
            return;
          } else {
            var dateFinalValidRevisedLEConsideredReceived = new Date(calculator.date_final_valid_revised_le_provided);
            calculator.date_final_valid_revised_le_considered_received = vm.advanceDate(dateFinalValidRevisedLEConsideredReceived, 3, 'Yes', calculator);
            return;
          }
        }
      }
    }

     // Number 35 on the specs. Almost same as above!
    function handleDateCDConsideredReceived(calculator) {
      if (calculator.how_initial_cd_provided == 'Hand delivered') {
        calculator.date_cd_considered_received = moment(calculator.date_initial_cd_provided);
      } else if (calculator.how_initial_cd_provided == 'Mailed') {
        if (calculator.date_documented_when_cd_actually_received) {
          calculator.date_cd_considered_received = moment(calculator.date_documented_when_cd_actually_received);
        } else if (calculator.date_documented_when_cd_actually_received == '') {
          var dateCDConsideredReceived = new Date(calculator.date_initial_cd_provided);
          calculator.date_cd_considered_received = vm.advanceDate(dateCDConsideredReceived, 3, 'Yes', calculator);
        }
      } else if (calculator.how_initial_cd_provided == 'Email') {        
        if (calculator.date_cd_affirmed) {
          calculator.date_cd_considered_received = moment(calculator.date_cd_affirmed);
        } else {
          dateCDConsideredReceived = new Date(calculator.date_initial_cd_provided);
          calculator.date_cd_considered_received = vm.advanceDate(dateCDConsideredReceived, 3, 'Yes', calculator);
        }
      }
    }

     // Special case for Revised Date Loan may Close for EMAIL.
    function handleRevisedDateLoanMayCloseForEmailedCD(calculator) {
      if (calculator.date_cd_affirmed) {
        var DateAffirmed = new Date(calculator.date_cd_affirmed);
        calculator.revised_earliest_date_loan_may_close = vm.advanceDate(DateAffirmed, 3, calculator.saturdays, calculator);
      }
    }

    // Special case for Revised Date Loan may Close for EMAIL, for REVISED CD.
    // vm.handleRevisedDateLoanMayCloseForEmailedRevisedCD = function (calculator) {
    //  var DateAffirmed = new Date(calculator.date_revised_cd_affirmed);
    //  calculator.revised_earliest_date_loan_may_close = vm.advanceDate(DateAffirmed, 3, calculator.saturdays, calculator);
    // };

    // Hey Cam, this is the test where the revised earliest date the loan may close reflects 3/20 which is 
    // prior to the 7th business day (3/21) the loan is permitted to close. That 7th business day rule begins on the date 
    // the LE was delivered/placed in the mail. It doesn't show it in the results, but I input 3/13 as the date the LE 
    // was delivered/placed in the mail. Again, it appears the "revised earliest date the loan may close" is only taking 
    // into consideration the date in which the CD is received. A person can close a loan 3 business days after 
    // they receive the CD, but it can still never be prior to that 7th business day from the date the LE is 
    // delivered/placed in the mail. Business days in this case is defined as all days including Saturday 
    // except Sundays and public holidays

     // Number 36. Based on date and how CD was provided.
    function handleRevisedDateLoanMayClose(calculator) {
      if (calculator.earliest_date_loan_may_close) {
        if (calculator.how_initial_cd_provided == 'Hand delivered') {
          var ThreeDayWait = new Date(calculator.date_cd_considered_received);

          if (calculator.earliest_date_loan_may_close > ThreeDayWait) {
            calculator.revised_earliest_date_loan_may_close = moment(calculator.earliest_date_loan_may_close);
          } else {
            calculator.revised_earliest_date_loan_may_close = vm.advanceDate(ThreeDayWait, 3, 'Yes', calculator);
          }
          
          return;
        }
        if (calculator.earliest_date_loan_may_close > calculator.date_cd_considered_received) {
          calculator.revised_earliest_date_loan_may_close = moment(calculator.earliest_date_loan_may_close);
        } else {
          calculator.revised_earliest_date_loan_may_close = moment(calculator.date_cd_considered_received);
        }
      }
    }

     // Number 37. based on optional input!
    function handleConsummationViolation(calculator) {
      if (calculator.date_anticipated_consummation != '' | calculator.date_anticipated_consummation != null) {
        calculator.revised_earliest_date_warning = Date(calculator.revised_earliest_date_loan_may_close) > Date(calculator.date_anticipated_consummation);
      }
    }

     // Number 44. based on 35.
    function handleDateRevisedCDConsideredReceived(calculator) {
      if (calculator.how_revised_cd_provided) {
        if (calculator.how_revised_cd_provided == 'In person') {
          calculator.date_revised_cd_considered_received = moment(calculator.date_revised_cd_provided);
          return vm.handleRevisedDateLoanMayCloseFromRevisedCD(calculator);
        } else if (calculator.how_revised_cd_provided != 'In person') {
          if (calculator.date_documented_for_actual_reception_of_revised_cd) {
            calculator.date_revised_cd_considered_received = moment(calculator.date_documented_for_actual_reception_of_revised_cd);
            return vm.handleRevisedDateLoanMayCloseFromRevisedCD(calculator);
          } else if (calculator.date_documented_for_actual_reception_of_revised_cd == '' ) {
            var dateRevisedCDConsideredReceived = new Date(calculator.date_revised_cd_provided);
            calculator.date_revised_cd_considered_received = vm.advanceDate(dateRevisedCDConsideredReceived, 6, 'Yes', calculator);
            return vm.handleRevisedDateLoanMayCloseFromRevisedCD(calculator);
          }
        }
      }
        // return vm.handleRevisedDateLoanMayCloseFromRevisedCD(); // CHECK!
    }

     // Number 45. Based on 36 but with additional date calculations.
    function handleRevisedDateLoanMayCloseFromRevisedCD(calculator) {
      if (calculator.reason_for_revised_cd == 'APR out of tolerance, Prepayment penalty added, or Loan Product changed') {
        var RevisedDateLoanMayCloseFromRevisedCD = new Date(calculator.date_revised_cd_considered_received);
        calculator.revised_earliest_date_loan_may_close_from_revised_cd = vm.advanceDate(RevisedDateLoanMayCloseFromRevisedCD, 3, 'Yes', calculator);
      } else if (calculator.reason_for_revised_cd == 'Other') {
        calculator.revised_earliest_date_loan_may_close_from_revised_cd = moment.max(moment(calculator.date_initial_cd_provided), moment(calculator.date_revised_cd_provided), moment(calculator.earliest_date_loan_may_close));
      }
      return vm.handleRevisedCDViolation(calculator); // for 46
    }

     // Number 46, message flasher.
    function handleRevisedCDViolation(calculator) {
      if(calculator.date_anticipated_consummation && calculator.revised_earliest_date_loan_may_close_from_revised_cd){
        calculator.revised_cd_violation_warning = Date(calculator.revised_earliest_date_loan_may_close_from_revised_cd) > calculator.date_anticipated_consummation;
      }
    }

     // Number 47. note the lazy conditional here! :)
    function handleDateFinalCDMustBeAvailable(calculator) {
      if (calculator.earliest_date_loan_may_close) {
        let NewRevisedDate;
        if (calculator.revised_earliest_date_loan_may_close_from_revised_cd) {
          NewRevisedDate = new Date(calculator.revised_earliest_date_loan_may_close_from_revised_cd);
        } else {
          NewRevisedDate = new Date(calculator.earliest_date_loan_may_close);
        }
        if (NewRevisedDate > Date(calculator.date_anticipated_consummation)) {
          calculator.date_final_cd_must_be_available = vm.backstepDate(NewRevisedDate, 1, calculator.saturdays, calculator);
        } else {
          var DateAnticipatedConsummation = new Date(calculator.date_anticipated_consummation);
          calculator.date_final_cd_must_be_available = vm.backstepDate(DateAnticipatedConsummation, 1, calculator.saturdays, calculator);
        }
      }
    }

     //Number 50. similar to 47 in a way. More lazy conditional to shut the output pane up. :)
    function handleEarliestDateFundsMayBeDisbursed(calculator) {
      if (calculator.date_anticipated_consummation) {
        let NewRevisedDate;
        if (calculator.revised_earliest_date_loan_may_close_from_revised_cd) {
          NewRevisedDate = new Date(calculator.revised_earliest_date_loan_may_close_from_revised_cd);
        } else if (calculator.revised_earliest_date_loan_may_close) {
          NewRevisedDate = new Date(calculator.revised_earliest_date_loan_may_close);
        }
        if (NewRevisedDate > Date(calculator.date_anticipated_consummation)) {
          calculator.earliest_date_funds_may_be_disbursed = vm.advanceDate(NewRevisedDate, 4, 'Yes', calculator);
          return;
        } else if (calculator.is_loan_rescindable == 'No'){
          var DateAnticipatedConsummation = new Date(calculator.date_anticipated_consummation);
          calculator.earliest_date_funds_may_be_disbursed = vm.advanceDate(DateAnticipatedConsummation, 0, 'Yes', calculator);
        } else {
          DateAnticipatedConsummation = new Date(calculator.date_anticipated_consummation);
          calculator.earliest_date_funds_may_be_disbursed = vm.advanceDate(DateAnticipatedConsummation, 4, 'Yes', calculator);
        }
      }
    }


     // Functions that aren't in the specs.

     // This one handles the rescission calculation.

    function handleAnticipatedActualDateOfClosing(calculator) {
      if (calculator.estimated_closing_date) {
        calculator.date_anticipated_consummation = moment(calculator.estimated_closing_date);
      }
    }

     // Requested by Greg. Section 1026.19(e)(4)(ii)
    function handleWarningOnEarlyCD(calculator) {
      if (calculator.date_initial_cd_provided) {
        if (calculator.date_final_valid_revised_le_considered_received) {
          if (calculator.how_final_valid_revised_le_provided == 'Hand Delivered') {
            if (calculator.date_final_valid_revised_le_considered_received === moment(calculator.date_initial_cd_provided)) {
              calculator.early_cd_warning = true;
              return;
            }
          }
        }
      }
    }

    function handleFinalDateToProvideCDForClosingDate(calculator) {
      if (calculator.date_anticipated_consummation && calculator.how_initial_cd_provided) {
        var date_anticipated_consummation = new Date(calculator.date_anticipated_consummation);

        if (calculator.how_initial_cd_provided == 'Mailed' || calculator.how_initial_cd_provided == 'Email') {
          calculator.date_final_provide_cd_closing_date = vm.backstepDate(date_anticipated_consummation, 6, 'Yes', calculator);
        } else {
          calculator.date_final_provide_cd_closing_date = vm.backstepDate(date_anticipated_consummation, 3, 'No', calculator);
        }
      } else {
        calculator.date_final_provide_cd_closing_date = '';
      }
    }

    function handleWarningOnLateLE(calculator) {
      var DateLEProvided = new Date(calculator.date_le_provided);
      var MustBeDelivered = new Date(calculator.date_init_le_must_be_delivered);
      calculator.date_le_provided_warning = MustBeDelivered < DateLEProvided;
    }

    function handleWarningOnLateRevisedLE(calculator) {
      var DateRevisedLEProvided = new Date(calculator.date_final_valid_revised_le_provided);
      var RevisedMustBeDelivered = new Date(calculator.date_final_le_must_be_delivered);
      calculator.date_revised_le_provided_warning = RevisedMustBeDelivered < DateRevisedLEProvided;
    }

  // Requested by Greg.
    function handleWarningOnLateCD(calculator) {
      let LateCDRangeCheck;
      if (calculator.how_initial_cd_provided) {
        var ConsummationDate = new Date(calculator.date_anticipated_consummation);
        var DateClosingDisclosureProvided = new Date(calculator.date_initial_cd_provided);
        if (calculator.how_initial_cd_provided == 'Email'){
          if (calculator.date_cd_affirmed) {
            var DateAffirmed = new Date(calculator.date_cd_affirmed);
            LateCDRangeCheck = vm.advanceDate(DateAffirmed, 3, 'Yes', calculator);
          } else {
            LateCDRangeCheck = vm.advanceDate(DateClosingDisclosureProvided, 6, 'Yes', calculator);
          }
        } else if (calculator.how_initial_cd_provided == 'Hand delivered') {
          LateCDRangeCheck = vm.advanceDate(DateClosingDisclosureProvided, 3, 'Yes', calculator);
        }

        else {
          if (calculator.how_initial_cd_provided == 'Mailed') {
            if (calculator.date_documented_when_cd_actually_received) {
              var DateRecieved = new Date(calculator.date_documented_when_cd_actually_received);
              LateCDRangeCheck = vm.advanceDate(DateRecieved, 3, 'Yes', calculator);
            } else {
              LateCDRangeCheck = vm.advanceDate(DateClosingDisclosureProvided, 6, 'Yes', calculator);
            }
          }
        }
        calculator.cd_exceeded_time_warning = LateCDRangeCheck > ConsummationDate;
      }
    }

    // Looks to be the same as the initial CD warning.
    function handleWarningOnLateRevisedCD(calculator) {
      let LateCDRangeCheck;
      if (calculator.how_revised_cd_provided) {
        var ConsummationDate = new Date(calculator.date_anticipated_consummation);
        var DateRevisedClosingDisclosureProvided = new Date(calculator.date_revised_cd_provided);
        if (calculator.how_revised_cd_provided == 'In person') {
          calculator.revised_cd_exceeded_time_warning = false;
          return;
        }
        else if (calculator.how_revised_cd_provided == 'Email') {
          if (calculator.date_revised_cd_affirmed) {
            var DateAffirmed = new Date(calculator.date_revised_cd_affirmed);
            LateCDRangeCheck = vm.advanceDate(DateAffirmed, 3, 'Yes', calculator);
          } else {
            LateCDRangeCheck = vm.advanceDate(DateRevisedClosingDisclosureProvided, 6, 'Yes', calculator);
          }
        } else {
          if (calculator.how_revised_cd_provided == 'Mailed') {
            LateCDRangeCheck = vm.advanceDate(DateRevisedClosingDisclosureProvided, 6, 'Yes', calculator);
          } else {
            LateCDRangeCheck = vm.advanceDate(DateRevisedClosingDisclosureProvided, 3, 'Yes', calculator);
          }
        }
        calculator.revised_cd_exceeded_time_warning = LateCDRangeCheck > ConsummationDate;
      }
    }
  }
  /* eslint-enable no-undef */
})();
